<template>
  <div class="active-resource">
    <div class="active-resource-top">
        <div class="title">活跃资源TOP5</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="active-resource-tab">
        <div class="tab-item" @click="changeTab('course')" :class="activeTab == 'course' ? 'is-active':''">
            <div class="name">课件</div>
        </div>
        <div class="tab-line"></div>
        <div class="tab-item" @click="changeTab('resource')" :class="activeTab == 'resource' ? 'is-active':''">
            <div class="name">科学可视化资源</div>
        </div>
        <div class="tab-line"></div>
        <div class="tab-item" @click="changeTab('video')" :class="activeTab == 'video' ? 'is-active':''">
            <div class="name">微课</div>
        </div>
        <div class="tab-line"></div>
        <div class="tab-item" @click="changeTab('board')" :class="activeTab == 'board' ? 'is-active':''">
            <div class="name">课例</div>
        </div>
    </div>
    <div class="resource-list">
        <div class="resource-li" v-for="(item,index) in resourceList" :key="item.id">
            <img :src="require('@/assets/images/hhxy.png')" v-if="activeTab == 'resource'">
            <img :src="addFsUrl(item.imgUrl)" v-else>
            <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="number">资源引用数：{{item.previews}}</div>
            </div>
        </div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'active-resource',
  data() {
    return {
        resourceList:[],
        activeTab:'resource'
    }
  },
  mounted(){
    this.changeTab(this.activeTab)
  },
  methods: {
    /**
     * @name 切换tab
     */
    changeTab(value){
      this.activeTab = value;
      let typeCode
      switch (this.activeTab) {
        case "course":
          typeCode = '31302'
          break
        case "resource":
          typeCode = ''
          break
        case "video":
          typeCode = '31306'
          break
        case "board":
          typeCode = '31308'
          break
      }
      this.getResourceList(typeCode)
    },
    getResourceList(typeCode){
      if( !typeCode ){
        this.resourceList = [
          {
            id:1,
            icon:require('@/assets/images/hhxy.png'),
            title:"双线段最值",
            previews:6524
          },
          {
            id:2,
            icon:require('@/assets/images/hhxy.png'),
            title:"用铅笔芯使电路中的电流连续地变化",
            previews:3256
          },
          {
            id:3,
            icon:require('@/assets/images/hhxy.png'),
            title:"化学变化过程中沉淀的生成和溶解",
            previews:2515
          },
          {
            id:4,
            icon:require('@/assets/images/hhxy.png'),
            title:"高原-南非高原",
            previews:4552
          },
          {
            id:5,
            icon:require('@/assets/images/hhxy.png'),
            title:"第三单元-多位数的大小比较",
            previews:1273
          }
        ]
        return
      }
      axios.get('https://tearesearch.iclass30.com/regionResource/resource/regionResourceHomeList', {
        params: {
          regionId: '546505e9b20a473ba03392ab01ca0572',
          orderType: 1,
          typeCode,
          page: 1,
          limit: 5
        }
      }).then((res)=>{
        this.resourceList = res.data.data.rows
      })
    },
    addFsUrl(url){
      if (!/http/g.test(url)) {
        return 'https://fs.iclass30.com/'+url
      }
      return url
    }
  }
}
</script>
<style lang='scss' scoped>
.active-resource{
  width: 100%;
  height: 570px;
  padding: 0 15px;
  border: 1px solid #053882;
  position: relative;
//   background: rgba(6,17,52,0.8);
  .active-resource-top{
      position: relative;
      text-align: center;
      margin-bottom: 15px;
      .title{
          display: inline-block;
          padding: 9px 22px 8px 17px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #D0E7FE;
          line-height: 20px;
          position: relative;
          z-index: 2;
      }
      .more{
          display: inline-block;
          position: absolute;
          top: 0px;
          right: 0px;
          height: 100%;
          line-height: 44px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #359AFF;
          cursor: pointer;
      }
      .title-bg{
          width: auto;
          height: 100%;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
      }
  }
  .active-resource-tab{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    .tab-item{
        display: inline-block;
        position: relative;
        cursor: pointer;
        .name{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2E87E3;
        }
    }
    .tab-line{
        width: 1px;
        height: 13px;
        background: linear-gradient(0deg, #061136 0%, #2E87E3 50%, #061136 100%);
        border-radius: 1px;
        margin: 0 10px;
    }
    .is-active{
        .name{
            font-weight: bold;
            color: #38FFF3;
            border-bottom: 2px solid;
            border-image: linear-gradient(to right, transparent, #38FFF3, transparent) 1;
        }
    }
  }
  .resource-list{
    padding: 0 5px;
    .resource-li{
        width: 100%;
        height: 70px;
        background: #0D1E54;
        border-radius: 6px;
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        padding: 13px 12px;
        cursor: pointer;
        img{
            width: 43px;
            height: 43px;
            background: #FE5600;
            border-radius: 6px;
            margin-right: 12px;
        }
        .info{
            width: calc(100% - 45px);
            text-align: left;
            .title{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #A0B5EA;
                margin-bottom: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
            }
            .number{
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #6EA0D3;
                text-align: left;
            }
        }
    }
    .resource-li:last-child(){
        margin-bottom: 0;
    }
  }
  .top-left{
      position: absolute;
      top: 0;
      left: 0;
      width: 14px;
      height: 14px;
  }
  .top-right{
      position: absolute;
      top: 0;
      right: 0;
      width: 14px;
      height: 14px;
  }
  .left-bottom{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 14px;
      height: 14px;
  }
  .right-bottom{
      position: absolute;
      bottom: 0;
      right: 0;
      width: 14px;
      height: 14px;
  }
}
</style>